/* eslint-disable react/prop-types */
import React from 'react';

import Auth0Config from '../config/auth0';
import Login from '../containers/Login';

const LoginPage = ({ auth0ConfigRaw }) => {
  const [config, setConfig] = React.useState();

  React.useEffect(() => {
    try {
      const c = JSON.parse(decodeURIComponent(escape(window.atob(auth0ConfigRaw))));
      setConfig(c);
    } catch (o) {
      //
    }
  }, [auth0ConfigRaw]);

  return <Login auth0Config={config} />;
};

export default LoginPage;

// we make use of getStaticProps()
// to "print" the template variable into
// HTML template, as part of __NEXT_DATA__
// so that Auth0 can replace the variable
// with actual config value
// BEFORE serving the HTML to the end use
export async function getStaticProps() {
  return {
    props: {
      auth0ConfigRaw: Auth0Config.configString,
    },
  };
}
